import { formatDate } from 'ha/helpers/hadate';
import {
  TypeValue,
  SuitableForValue,
  RoomsValue,
} from 'ha/types/SearchFilters';
import { CanonicalFurniture, CanonicalBills } from 'ha/constants/Filters';
import {
  CanonicalCollections,
  TranslatedCollectionToCanonical,
} from 'ha/constants/SearchPageCollections';

const CanonicalCollectionToFilter = (stats: CollectionStats) => ({
  [TypeValue.PRIVATE_ROOM]: { categories: [TypeValue.PRIVATE_ROOM] },
  [TypeValue.SHARED_ROOM]: { categories: [TypeValue.SHARED_ROOM] },
  [TypeValue.APARTMENT]: {
    categories: [TypeValue.APARTMENT],
  },
  [TypeValue.STUDIO]: {
    categories: [TypeValue.STUDIO],
  },
  [CanonicalCollections.CheapAccommodation]: {
    priceMin: 0,
    priceMax: stats.averagePrice,
    currency: 'EUR',
  },
  [CanonicalCollections.FurnishedApartments]: {
    furniture: CanonicalFurniture.Furnished,
    categories: [TypeValue.APARTMENT],
  },
  [CanonicalCollections.StudentAccommodation]: {
    furniture: CanonicalFurniture.Furnished,
    bills: CanonicalBills.Included,
    suitableFor: SuitableForValue.STUDENTS,
  },
  [CanonicalCollections.LongTermRentals]: {
    startDate: formatDate('en', 'YYYY-MM-DD', Date.now()),
  },
  [CanonicalCollections.OneBedroomApartments]: {
    categories: [TypeValue.APARTMENT],
    rooms: {
      bedroomCount: [RoomsValue.ONE],
    },
    bedroomCount: [RoomsValue.ONE],
  },
  [CanonicalCollections.TwoBedroomApartments]: {
    categories: [TypeValue.APARTMENT],
    rooms: {
      bedroomCount: [RoomsValue.TWO],
    },
    bedroomCount: [RoomsValue.TWO],
  },
  [CanonicalCollections.StudentRoom]: {
    categories: [TypeValue.PRIVATE_ROOM, TypeValue.SHARED_ROOM],
    furniture: CanonicalFurniture.Furnished,
    bills: CanonicalBills.Included,
    suitableFor: SuitableForValue.STUDENTS,
  },
});

interface CollectionStats {
  averagePrice: number;
}

const collectionToFilters = (
  translatedCollection: string,
  stats: CollectionStats,
): object => {
  if (!translatedCollection) {
    return {};
  }

  const canonicalKey = TranslatedCollectionToCanonical[translatedCollection];

  return canonicalKey ? CanonicalCollectionToFilter(stats)[canonicalKey] : {};
};

export default collectionToFilters;
